import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Sustain-SBI.svg")